import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Currency } from '@app/shared/services/currencies/currencies.service';
import { PromoCode, PromoCodeType } from '../../services/direct.service';

@Component({
  standalone: false,
  selector: 'sbnb-promo-codes-edit-codes',
  templateUrl: './promo-codes-edit-codes.component.html',
  styleUrls: ['./promo-codes-edit-codes.component.scss'],
})
export class PromoCodesEditCodesComponent implements AfterViewInit {
  @Input() promoCode: PromoCode;
  @Input() currencies: Currency[] = [];
  @Input() hideHeader: boolean = false;
  @Input() shouldFocus: boolean = true;

  PromoCodeType = PromoCodeType;

  @ViewChild('codeInput') codeInput: ElementRef<HTMLInputElement>;
  @Output() promoCodeTypeChanged: EventEmitter<boolean> = new EventEmitter();
  @Output() currencyChanged: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngAfterViewInit() {
    if (this.shouldFocus) {
      setTimeout(() => {
        this.codeInput.nativeElement.focus();
      }, 0);
    }
  }

  validateCodeInput(input: any) {
    // Allow letters, numbers, hyphens, and underscores only
    input.value = input.value.replace(/[^0-9a-zA-Z\-_]/g, '');
  }

  checkFixedBounds(): void {
    if (this.promoCode.discount_amount < 1) {
      this.promoCode.discount_amount = 1;
    }
  }

  checkPercentageBounds(): void {
    if (this.promoCode.discount_amount < 1) {
      this.promoCode.discount_amount = 1;
    } else if (this.promoCode.discount_amount > 99) {
      this.promoCode.discount_amount = 99;
    }
  }

  checkMaxDiscountBounds(): void {
    if (this.promoCode.max_discount < 0) {
      this.promoCode.max_discount = null;
    }
  }

  addCode(newCode: string) {
    if (!newCode) return;
    if (newCode.length < 2) return;
    this.promoCode.codes.push(newCode.toUpperCase());
    this.codeInput.nativeElement.value = '';
  }

  removeCode(code: string) {
    this.promoCode.codes = this.promoCode.codes.filter((c) => c !== code);
  }

  setPercentageType() {
    this.promoCode.discount_type = PromoCodeType.Percentage;
    this.promoCode.discount_amount = parseInt(this.promoCode.discount_amount.toString());
    this.promoCodeTypeChanged.emit();
  }

  updateCurrency(currency: Currency) {
    this.promoCode.discount_type = PromoCodeType.Fixed;
    this.promoCode.currency = currency.key;
    this.promoCode.properties = [];

    this.currencyChanged.emit(true);
  }
}
